import { Component, OnInit, Input } from '@angular/core';
import { templateJitUrl } from '@angular/compiler';
import { HttpService } from 'src/app/services/http/http.service';

@Component({
  selector: 'app-template-structure',
  templateUrl: './template-structure.component.html',
  styleUrls: ['./template-structure.component.scss']
})
export class TemplateStructureComponent implements OnInit {
@Input() template;
  templateList: any;         
  constructor( 
    ) { }

  ngOnInit() {
  }

 
}
